module.exports = __webpack_public_path__ + "static/base-3-cf17adb2711b64f66707e365e7f802c2.jpg";